export const BEGatewayQueryContext = {
  context: {
    clientName: 'be-gateway',
  },
};
